'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGroup$002dName$0024$0024anon$002472 from "./presto.types$-Group-Name$$anon$72.js";
import * as $j_presto$002etypes$0024$002dGroup$002dName$0024$0024anon$002473 from "./presto.types$-Group-Name$$anon$73.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupName$() {
  this.c7S = null;
  this.c7T = false;
  this.c7Q = null;
  this.c7R = false;
  this.c7W = null;
  this.c7X = false;
  this.c7U = null;
  this.c7V = false;
  this.c7Y = null;
  this.c7Z = false;
}
export { $c_Lpresto_types$GroupName$ as $c_Lpresto_types$GroupName$ };
$p = $c_Lpresto_types$GroupName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupName$;
/** @constructor */
function $h_Lpresto_types$GroupName$() {
}
export { $h_Lpresto_types$GroupName$ as $h_Lpresto_types$GroupName$ };
$h_Lpresto_types$GroupName$.prototype = $p;
$p.ae6 = (function() {
  if ((!this.c7T)) {
    this.c7S = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c7T = true;
  }
  return this.c7S;
});
$p.mm = (function() {
  if ((!this.c7R)) {
    this.c7Q = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c7R = true;
  }
  return this.c7Q;
});
$p.ct7 = (function() {
  if ((!this.c7X)) {
    this.c7W = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c7X = true;
  }
  return this.c7W;
});
$p.Tn = (function() {
  if ((!this.c7V)) {
    this.c7U = new $j_presto$002etypes$0024$002dGroup$002dName$0024$0024anon$002472.$c_Lpresto_types$GroupName$$anon$72(this);
    this.c7V = true;
  }
  return this.c7U;
});
$p.cK3 = (function() {
  if ((!this.c7Z)) {
    this.c7Y = new $j_presto$002etypes$0024$002dGroup$002dName$0024$0024anon$002473.$c_Lpresto_types$GroupName$$anon$73(this);
    this.c7Z = true;
  }
  return this.c7Y;
});
var $d_Lpresto_types$GroupName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupName$, "presto.types$GroupName$", ({
  a0j: 1,
  D: 1
}));
export { $d_Lpresto_types$GroupName$ as $d_Lpresto_types$GroupName$ };
var $n_Lpresto_types$GroupName$;
function $m_Lpresto_types$GroupName$() {
  if ((!$n_Lpresto_types$GroupName$)) {
    $n_Lpresto_types$GroupName$ = new $c_Lpresto_types$GroupName$();
  }
  return $n_Lpresto_types$GroupName$;
}
export { $m_Lpresto_types$GroupName$ as $m_Lpresto_types$GroupName$ };
//# sourceMappingURL=presto.types$-Group-Name$.js.map
